export default __webpack_public_path__ + "static/media/dashboard-female-icon.65fbf9b7.svg";